<template>
  <div>
    <newCliente />
  </div>
</template>

<script>
import newCliente from "../components/newCliente.vue";

export default {
  components: {
    newCliente,
  },
  data: () => ({
    //
  }),
};
</script>
